(function(window, themeControllerFactory) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.themeController = themeControllerFactory(window, namespace.externalMessageController, namespace.themeNames, namespace.playerConfiguration);
})(this, function(window, externalMessageController, themeNames, playerConfiguration) {
   'use strict';
   
   var _$spElement = null;

   var setTheme = function(themeName) {
      playerConfiguration.setTheme(themeName);
      applyTheme();
   };

   var registerCallback = function() {
      externalMessageController.addCallback('SET_THEME', setTheme);
   };

   var setSmartPlayerContainerElement = function($element) {
      _$spElement = $element;
      applyTheme();
   };

   var getClassNameForTheme = function(theme) {
      return 'smartplayer-' + theme + '-theme';
   };

   var applyTheme = function() {
      if (_$spElement) {
         var themeClassNameAsString = Object.keys(themeNames).reduce(function(accumulator, currentValue) {
            return accumulator + getClassNameForTheme(themeNames[currentValue]) + ' ';
         }, '');

         var currentThemeClassName = getClassNameForTheme(playerConfiguration.getTheme());
         _$spElement.removeClass(themeClassNameAsString);
         _$spElement.addClass(currentThemeClassName);
      }
   };

   registerCallback();

   return {
      setTheme: setTheme,
      setSmartPlayerContainerElement: setSmartPlayerContainerElement
   };
});
